/* eslint-disable @stylistic/brace-style */
import i18next from 'i18next';

import { StreamStatusValue } from '../../../shared/ui/stream-statuses';

export const STATUS_LABEL_KEYS: Record<number, string> = {
  get [StreamStatusValue.pending]() { return i18next.t('monokit:stream statuses.pending'); },
  get [StreamStatusValue.in_progress]() { return i18next.t('monokit:stream statuses.in_progress'); },
  get [StreamStatusValue.done]() { return i18next.t('monokit:stream statuses.done'); },
  get [StreamStatusValue.restart]() { return i18next.t('monokit:stream statuses.restart'); },
  get [StreamStatusValue.failure]() { return i18next.t('monokit:stream statuses.failure'); },
  get [StreamStatusValue.stop]() { return i18next.t('monokit:stream statuses.stop'); },
  get [StreamStatusValue.unknown]() { return i18next.t('monokit:stream statuses.unknown'); },
  get [StreamStatusValue.handler_lost]() { return i18next.t('monokit:stream statuses.handler_lost'); },
  get [StreamStatusValue.paused]() { return i18next.t('monokit:stream statuses.paused'); },
};
